module.exports = "<p>\r\n  transformer-dashboard works!\r\n</p>\r\n"